import { type ReactNode } from 'react';
import cn from 'classnames';
import { TileHeader, TileTabsRow } from '@creditflowresearch/uilib/Tile';
import Title from '@creditflowresearch/uilib/Title';
import { ITabSubtypeItem } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/ITabItem';
import ArticlesTypesTabs from './ArticlesTypesTabs';

import tabsStyles from '@creditflowresearch/uilib/styles/tabs.module.scss';
import styles from './articlesTileHeader.module.scss';

interface IArticlesTileHeaderProps {
  title: string,
  tabs: ITabSubtypeItem[],
  basePath: string,
  children?: ReactNode,
}

const ArticlesTileHeader = ({ title, tabs, basePath, children }: IArticlesTileHeaderProps) => (
  <>
    <TileHeader
      title={ <Title title={ title } /> }
      hideTitleOnDesktop={ tabs.length > 0 }
      noDesktopBottomBorder={ tabs.length > 0 }
      className={ styles.controlsRow }
      dataTest="articlesTileHeader"
    >
      { children }
    </TileHeader>
    { tabs.length > 0 && (
      <TileTabsRow dataTest="articlesSubtypeTabs">
        <ArticlesTypesTabs<ITabSubtypeItem>
          tabs={ tabs }
          basePath={ basePath }
          activeClassName={ tabsStyles.isTabActive }
          tabItemClassName={ cn(tabsStyles.tab) }
        />
      </TileTabsRow>
    ) }
  </>
);

export default ArticlesTileHeader;
